import {finalize} from "rxjs/operators";
import {NgOptimizedImage} from "@angular/common";
import {NzModalService} from "ng-zorro-antd/modal";
import {FeedbackService} from "@app/shared/services";
import {NzMessageService} from "ng-zorro-antd/message";
import {openChat} from "@app/shared/helpers/chat-helpers";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {AppStateService} from "@app/shared/services/app-state.service";
import {NzDropdownDirective, NzDropdownMenuComponent} from "ng-zorro-antd/dropdown";
import {CouponBannerComponent} from "@app/shared/ui-kits/coupon-banner/coupon-banner.component";
import {NzMenuDirective, NzMenuDividerDirective, NzMenuItemComponent} from "ng-zorro-antd/menu";
import {SendFeedbackComponent} from "@app/shared/ui-kits/send-feedback/send-feedback.component";

@Component({
  selector: 'sf-helper',
  templateUrl: './helper.component.html',
  styleUrl: './helper.component.scss',
  imports: [
    NgOptimizedImage,
    NzDropdownDirective,
    NzDropdownMenuComponent,
    NzMenuDirective,
    NzMenuDividerDirective,
    NzMenuItemComponent,
    TranslateModule
  ]
})
export class HelperComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly nzModalService = inject(NzModalService);
  private readonly feedbackService = inject(FeedbackService);
  protected readonly appStateService = inject(AppStateService);
  protected readonly translateService = inject(TranslateService);
  private readonly nzMessageService = inject(NzMessageService);

  constructor() {
  }

  ngOnInit() {
  }

  protected openChat() {
    openChat();
  }

  protected openFeedbackModal() {
    const modalRef = this.nzModalService.create({
      nzContent: SendFeedbackComponent,
      nzCentered: true,
      nzFooter: null
    });

    const component = modalRef.componentInstance;

    component?.close$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        modalRef.close();
      });

    component?.save$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((feedback) => {
        component!.btnLoaderState = true;
        this.feedbackService.sendFeedback(feedback)
          .pipe(
            finalize(() => component!.btnLoaderState = false),
            takeUntilDestroyed(this.destroyRef)
          )
          .subscribe(() => {
            modalRef.close();
            this.nzMessageService.success(
              this.translateService.instant('project_messages.thanks_for_feedback')
            );
          });
      });
  }

  protected onReferFriend() {
    this.nzModalService.create({
      nzContent: CouponBannerComponent,
      nzFooter: null,
      nzClosable: false
    });
  }

}
